<ng-container *ngIf="itinerarySnapshots$ | async; let itinerarySnapshots">
  <mat-accordion [multi]="true">
    <mat-expansion-panel
      *ngFor="let snapshot of itinerarySnapshots; index as index"
    >
      <mat-expansion-panel-header>
        <mat-panel-title fxLayoutAlign="start center">
          <mat-icon class="header-icon">label</mat-icon>
          <span class="header-title" fxFlex>
            <span fxFlex>
              <span>{{ snapshot.timestamp.toDate() | date: "short" }}</span>
            </span>
            <span>{{ snapshot.itinerary.assigneeData?.email }}</span>
            <span>&nbsp;—&nbsp;</span>
            <span>{{ snapshot.itinerary.status | itineraryStatusLabel }}</span>
          </span>
          <div class="header-actions">
            <button
              mat-icon-button
              matTooltip="Ripristina"
              [disabled]="snapshot.itinerary.status != itinerary.status"
              (click)="restore(snapshot)"
            >
              <mat-icon aria-label="Ripristina">history</mat-icon>
            </button>
          </div>
        </mat-panel-title>
      </mat-expansion-panel-header>

      <div fxLayout="row" fxFlex>
        <div fxFlex>
          <div class="item">
            <h4>
              <b>Destinazione</b>
            </h4>
            <p>
              <small>
                {{ snapshot.itinerary.destination }}
              </small>
            </p>
          </div>
          <div class="item">
            <h4>
              <b>Date</b>
            </h4>
            <p>
              <small *ngIf="snapshot.itinerary.start && snapshot.itinerary.end">
                {{ snapshot.itinerary.start.toDate() | date }} ›
                {{ snapshot.itinerary.end.toDate() | date }}
              </small>
            </p>
          </div>
          <div class="item">
            <h4>
              <b>Numero persone</b>
            </h4>
            <p>
              <small>
                {{ snapshot.itinerary.npax }}
              </small>
            </p>
          </div>
          <div class="item">
            <h4>
              <b>Titolo</b>
            </h4>
            <p>
              <small>
                {{ snapshot.itinerary.title }}
              </small>
            </p>
          </div>
          <div class="item">
            <h4>
              <b>Descrizione</b>
            </h4>
            <p>
              <small>
                {{ snapshot.itinerary.description }}
              </small>
            </p>
          </div>
          <div class="item">
            <h4>
              <b>Informazioni aggiuntive</b>
            </h4>
            <p>
              <small>
                {{ snapshot.itinerary.additionalInfo }}
              </small>
            </p>
          </div>
        </div>

        <div fxFlex *ngIf="snapshot.itinerary.reservations">
          <div class="item">
            <h4>
              <b>Voli</b> ({{ snapshot.itinerary.reservations.flights.length }})
            </h4>
            <p
              *ngFor="
                let reservation of snapshot.itinerary.reservations.flights
              "
            >
              <small>
                <app-itinerary-reservations-transportation-form-title
                  [transportation]="reservation"
                ></app-itinerary-reservations-transportation-form-title>
              </small>
            </p>
          </div>
          <div class="item">
            <h4>
              <b>Alloggi</b> ({{
                snapshot.itinerary.reservations.accomodations.length
              }})
            </h4>
            <p
              *ngFor="
                let reservation of snapshot.itinerary.reservations.accomodations
              "
            >
              <small>
                <app-itinerary-reservations-accomodation-form-title
                  [accomodation]="reservation"
                ></app-itinerary-reservations-accomodation-form-title>
              </small>
              <small>
                —
                <span
                  *ngFor="let proposal of reservation.proposals; last as last"
                  >{{ proposal.name }} <span *ngIf="!last">, </span></span
                ></small
              >
            </p>
          </div>
          <div class="item">
            <h4>
              <b>Treni</b> ({{ snapshot.itinerary.reservations.trains.length }})
            </h4>
            <p
              *ngFor="let reservation of snapshot.itinerary.reservations.trains"
            >
              <small>
                <app-itinerary-reservations-transportation-form-title
                  [transportation]="reservation"
                ></app-itinerary-reservations-transportation-form-title>
              </small>
            </p>
          </div>
          <div class="item">
            <h4>
              <b>Navi</b> ({{ snapshot.itinerary.reservations.ferries.length }})
            </h4>
            <p
              *ngFor="
                let reservation of snapshot.itinerary.reservations.ferries
              "
            >
              <small>
                <app-itinerary-reservations-transportation-form-title
                  [transportation]="reservation"
                ></app-itinerary-reservations-transportation-form-title>
              </small>
            </p>
          </div>
          <div class="item">
            <h4>
              <b>Autobus</b> ({{
                snapshot.itinerary.reservations.buses.length
              }})
            </h4>
            <p
              *ngFor="let reservation of snapshot.itinerary.reservations.buses"
            >
              <small>
                <app-itinerary-reservations-transportation-form-title
                  [transportation]="reservation"
                ></app-itinerary-reservations-transportation-form-title>
              </small>
            </p>
          </div>
          <div class="item">
            <h4>
              <b>Altri mezzi</b> ({{
                snapshot.itinerary.reservations.cars.length
              }})
            </h4>
            <p *ngFor="let reservation of snapshot.itinerary.reservations.cars">
              <small>
                <app-itinerary-reservations-car-form-title
                  [car]="reservation"
                ></app-itinerary-reservations-car-form-title>
              </small>
            </p>
          </div>
        </div>

        <div fxFlex *ngIf="snapshot.itinerary.days">
          <div
            class="item"
            *ngFor="let day of snapshot.itinerary.days; index as index"
          >
            <h4>
              <b>Giorno {{ index + 1 }}</b>
            </h4>
            <p>
              <small>
                {{ day.title }}
              </small>
            </p>
            <p>
              <small>
                {{ day.description }}
              </small>
            </p>
            <p>
              <small>{{ day.activities.length }} <i>Attività</i></small>
            </p>
            <p>
              <small>
                {{ getNotGeneratedPois(day.pois).length }}
                <i>Luoghi da Scoprire</i>
              </small>
            </p>
          </div>
        </div>
      </div>
    </mat-expansion-panel>
  </mat-accordion>

  <app-empty-list-message
    *ngIf="itinerarySnapshots.length == this.limit"
    actionLabel="Carica altri elementi"
    (actionClick)="limit = limit + 10; list()"
  >
  </app-empty-list-message>
</ng-container>
